import { useUser } from '~/hooks/user';
import { useSseNotificationsContext } from '~/contexts/sse-notifications-context';
import { mergeLearnerGamificationStats } from '~/lib/gamification-utils';
import { cn } from '~/lib/utils';
import { GamificationLoginStat } from '~/components/ui/gamification/gamification-login-stat';
import { GameStats } from '~/components/ui/gamification/game-stats';

export type LearnerGamificationMetrics = {
  loginsThisWeek: number;
  totalXp: number;
  totalStars: number;
  weeklyLoginWeekdays: number[];
  requiredLoginDays: number;
  weeklyBonusXp: number;
};

export type GamificationMetricsProps = LearnerGamificationMetrics & {
  className?: string;
};

export function GamificationMetrics({
  loginsThisWeek,
  totalXp,
  totalStars,
  weeklyLoginWeekdays,
  requiredLoginDays,
  weeklyBonusXp,
  className,
}: GamificationMetricsProps) {
  return (
    <div className={cn('flex items-start gap-md', className)}>
      <GamificationLoginStat
        value={loginsThisWeek}
        maxValue={requiredLoginDays}
        weeklyLoginWeekdays={weeklyLoginWeekdays}
        bonusXp={weeklyBonusXp}
      />
      <GameStats type="xp" value={totalXp} />
      <GameStats type="stars" value={totalStars} />
    </div>
  );
}

export function GamificationPills({ className }: { className?: string }) {
  const user = useUser();
  const sseNotifications = useSseNotificationsContext();

  if (user?.accountType !== 'LEARNER' || !user.gamificationProfile) {
    return null;
  }

  const merged = mergeLearnerGamificationStats(user.gamificationProfile, sseNotifications?.stats);

  return (
    <GamificationMetrics
      loginsThisWeek={merged.weeklyLoginDays}
      totalXp={merged.totalXp}
      totalStars={merged.totalStars}
      weeklyLoginWeekdays={merged.weeklyLoginWeekdays}
      requiredLoginDays={merged.requiredLoginDays}
      weeklyBonusXp={merged.weeklyBonusXp}
      className={className}
    />
  );
}
